import { render, staticRenderFns } from "./FieldDate.vue?vue&type=template&id=38f4238f"
import script from "./FieldDate.vue?vue&type=script&lang=js"
export * from "./FieldDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports